import React from 'react';
import { View, Text } from '../../../app-components';
import navigationBarStyle from './navigationBarStyle';

import vars from '../../../theme/vars';

const { colors } = vars;

const Footer = ({ navigation }) => {
  const { routeName } = navigation?.state;
  const currentYear = new Date().getFullYear();

  return (
    <View
      style={{
        ...navigationBarStyle.containerStyle,
        backgroundColor: routeName === 'landing' ? colors.sidebarBgBlackColor : colors.grey.color8,
      }}
    >
      <Text
        style={{
          ...navigationBarStyle.tabText,
          color: routeName === 'landing' ? colors.grey.color8 : colors.grey.color7,
        }}
      >
      © {currentYear} APPRAISE ALL LTD. All Rights Reserved.
      </Text>
    </View>
  );
};

export default Footer;
